import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
export const useShellTranslation = () => {
    const { t } = useTranslation('app_pric');
    return {
        t,
    };
};
